module.exports = __webpack_public_path__ + "img/point.d6ce6d6b.svg";